export default __webpack_public_path__ + "static/media/EAST1040.34I-34097_-18304_0.ab1812a8.jpg";